import { render, staticRenderFns } from "./ListReclamos.vue?vue&type=template&id=67d5f21b&scoped=true"
import script from "./ListReclamos.vue?vue&type=script&lang=js"
export * from "./ListReclamos.vue?vue&type=script&lang=js"
import style0 from "./ListReclamos.vue?vue&type=style&index=0&id=67d5f21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5f21b",
  null
  
)

export default component.exports